import type { MaybeRef } from 'vue';
import {
  buildBreadcrumbList,
  injectJsonLdScript,
  type BreadcrumbCrumb,
} from './useJsonLdShared';

/**
 * Injects a standalone BreadcrumbList JSON-LD script.
 * Pass crumbs defined per template — do not auto-derive from the URL.
 */
export function useBreadcrumbJsonLd(
  crumbs: MaybeRef<BreadcrumbCrumb[] | null | undefined>,
  pageUrl: MaybeRef<string | null | undefined>,
  scriptKey = 'breadcrumb-jsonld',
) {
  const jsonLd = computed(() => {
    const items = unref(crumbs);
    const url = unref(pageUrl)?.trim();
    if (!items?.length || !url) {
      return null;
    }

    return {
      '@context': 'https://schema.org',
      ...buildBreadcrumbList(`${url}#breadcrumb`, items),
    };
  });

  injectJsonLdScript(scriptKey, jsonLd);
}
